/* eslint-disable @typescript-eslint/naming-convention */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { JobPreferencesDataRequest } from '../../../typings';

@Injectable()
export class JobPreferencesService {
  private readonly _jobPreferencesData = new BehaviorSubject<JobPreferencesDataRequest>({
    talentId: -1,
    formId: '',
    fromRedeployEmail: false,
    jobPreferences: {
      talentId: -1,
      updateSource: -1,
      updatingPersonId: -1,
      phone: '',
      hasPrimaryPhone: false,
      resumeLink: {
        redirectLink: '',
        displayLink: ''
      },
      resume: {
        fileName: '',
        lastUpdatedDate: ''
      }
    },
    money: {
      minimumHourlyRate: null,
      desiredHourlyRate: null,
      minimumYearlySalary: null,
      desiredYearlySalary: null
    },
    opportunity: {
      contractSelected: false,
      contractToHireSelected: false,
      permanentSelected: false,
      partTimeSelected: false,
      fullTimeSelected: false,
      onSiteSelected: false,
      offSiteSelected: false,
      hybridSelected: false
    },
    availability: {
      availabilityDate: '',
      preAuthorizedSubmittal: false,
      availabilityType: -1,
      numWeeksNoticeNeeded: -1
    },
    travel: {
      personId: -1,
      homeLocation: '',
      homeLocationLatitude: -1,
      homeLocationLongitude: -1,
      modifyingPersonId: -1
    }
  });
  readonly jobPreferencesData$ = this._jobPreferencesData.asObservable().pipe(distinctUntilChanged());

  private readonly _isApplication = new BehaviorSubject(false);
  readonly isApplication$ = this._isApplication.asObservable().pipe(distinctUntilChanged());

  private readonly _isRegistration = new BehaviorSubject(false);
  readonly isRegistration$ = this._isApplication.asObservable().pipe(distinctUntilChanged());

  private readonly _countryId = new BehaviorSubject(-1);
  readonly countryId$ = this._isApplication.asObservable().pipe(distinctUntilChanged());

  private readonly _showEeocForm = new BehaviorSubject(false);
  readonly showEeocForm$ = this._showEeocForm.asObservable().pipe(distinctUntilChanged());

  set jobPreferencesData(val: JobPreferencesDataRequest) {
    this._jobPreferencesData.next(val);
  }

  get jobPreferencesData(): JobPreferencesDataRequest {
    return this._jobPreferencesData.getValue();
  }

  set isApplication(val: boolean) {
    this._isApplication.next(val);
  }

  get isApplication(): boolean {
    return this._isApplication.getValue();
  }

  set isRegistration(val: boolean) {
    this._isRegistration.next(val);
  }

  get isRegistration(): boolean {
    return this._isRegistration.getValue();
  }

  set countryId(val: number) {
    this._countryId.next(val);
  }

  get countryId(): number {
    return this._countryId.getValue();
  }

  set showEeocForm(val: boolean) {
    this._showEeocForm.next(val);
  }

  get showEeocForm(): boolean {
    return this._showEeocForm.getValue();
  }

  // #FUTUREADD
  // If more fields get added to the job preferences form we'll need to check them here.
  isJobPreferencesDataBlank(): boolean {
    const data = this._jobPreferencesData.getValue();
    const money: string[] = Object.keys(data.money);
    const opportunity: string[] = Object.keys(data.opportunity);
    for (const key of money) {
      if (data.money[key] !== null) {
        return false;
      }
    }
    for (const key of opportunity) {
      if (data.opportunity[key]) {
        return false;
      }
    }
    return true;
  }
}
